import { render, staticRenderFns } from "./SelectAccreditation.vue?vue&type=template&id=1c4c0566&scoped=true"
import script from "./SelectAccreditation.vue?vue&type=script&lang=js"
export * from "./SelectAccreditation.vue?vue&type=script&lang=js"
import style0 from "./SelectAccreditation.vue?vue&type=style&index=0&id=1c4c0566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c0566",
  null
  
)

export default component.exports